import elements from '../store/elements'
import { state, isCustomProduct, isGiftCard } from '../store/state'
import scrollTo from '../helpers/scrollTo'
import triggers from '../store/triggers'
import { isNotNullOrUndef } from '../../../js/helpers/isNotNullOrUndef'
import setSizeToImgSrc from '../helpers/setSizeToImgSrc'

const doc = document
const win = window

const sizesWrapper = doc.querySelector('.selector-wrapper--size')
const outsideBtnWrapper = elements.form.querySelector('.outside-wrapper-product-button')
const insideBtnWrapper = outsideBtnWrapper.querySelector('.inside-wrapper-product-button')
const disabledText = doc.querySelector('#disabled-cart-text')
let btnSticky = false
let timer

const mobileViewBreakpoint = 1200
const stickyBreakpoint = 1200
const btnImageBreakpoint = 1200

// click on add btn if btn disabled
insideBtnWrapper.querySelector('button[type="submit"]').addEventListener('click', (event) => {
  if (!state.cartDisabled) return
  event.preventDefault()

  if (!isCustomProduct) {
    // default products

    // scroll to form on mobile devices
    if (window.matchMedia(`(max-width: ${stickyBreakpoint}px)`).matches) {
      scrollTo(outsideBtnWrapper.getBoundingClientRect().bottom + win.pageYOffset + 10 - win.innerHeight)
    }

    // Show notify choose and add blink to sizes
    sizesWrapper.classList.remove('notify-choose')
    disabledText !== null && disabledText.classList.remove('blink-it')
    if (sizesWrapper.offsetWidth) {
      sizesWrapper.classList.add('notify-choose')
      disabledText !== null && disabledText.classList.add('blink-it')
    }
  } else if (window.matchMedia(`(max-width: ${mobileViewBreakpoint}px)`).matches) {
    // custom products
    outsideBtnWrapper.classList.add('show-tooltip')
    timer && clearTimeout(timer)
    timer = setTimeout(() => {
      outsideBtnWrapper.classList.remove('show-tooltip')
    }, 2000)
  }
})

// Remove notify and blink from sizes for default products
const removeNotify = () => {
  sizesWrapper.classList.remove('notify-choose')
  disabledText !== null && disabledText.classList.remove('blink-it')
}

// Toggle disabled state for add to cart button
const toggleBtnDisabled = disabled => {
  if (disabled) {
    outsideBtnWrapper.classList.add('add-btn--disabled')
  } else {
    outsideBtnWrapper.classList.remove('add-btn--disabled')
  }
}

// Sticky button for mobile
if (window.matchMedia(`(max-width: ${stickyBreakpoint}px)`).matches) {
  const observer = new global.IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (btnSticky) {
          insideBtnWrapper.removeAttribute('data-ga-event')
          outsideBtnWrapper.classList.remove('add-button--sticky')
          outsideBtnWrapper.style.height = ''
          btnSticky = false
          // hide help center btn
          doc.querySelector('.fixed-help__container')?.removeAttribute('hidden')
          // hide welcome popup reminder
          doc.querySelector('.ft-pop__reminder')?.removeAttribute('hidden')
        }
      } else {
        if (!btnSticky && outsideBtnWrapper.getBoundingClientRect().bottom < 0) {
          outsideBtnWrapper.style.height = outsideBtnWrapper.offsetHeight + 'px'
          insideBtnWrapper.dataset.gaEvent = '["Product page - mobile", "Click", "Sticky ATC"]'
          outsideBtnWrapper.classList.add('add-button--sticky')
          btnSticky = true
          // show help center btn
          doc.querySelector('.fixed-help__container')?.setAttribute('hidden', '')
          // show welcome popup reminder
          doc.querySelector('.ft-pop__reminder')?.setAttribute('hidden', '')
        }
      }
    })
  })
  observer.observe(outsideBtnWrapper)
}

const addButton = () => {
  // Remove notify and blink from sizes for default products
  if (!isCustomProduct && !isGiftCard) {
    removeNotify()
    triggers.on('state:size', removeNotify)
  }

  // Toggle disabled state for add to cart button
  toggleBtnDisabled(state.cartDisabled)
  triggers.on('state:cartDisabled', toggleBtnDisabled)

  // Image and price for mobile button
  if (window.matchMedia(`(max-width: ${btnImageBreakpoint}px)`).matches && !isCustomProduct) {
    const variantImage = doc.createElement('img')
    const orderInfoEl = doc.createElement('div')
    const imgSrc = isNotNullOrUndef(elements.image) ? `${elements.image.src}` : ''

    variantImage.id = 'variant-image-ab'
    variantImage.src = imgSrc
    variantImage.srcset = [60, 120, 180, 240, 300, 360].map(size => `${setSizeToImgSrc(imgSrc, size)} ${size}w`).join(',')
    variantImage.loading = 'lazy'
    variantImage.sizes = '13.8667vw'
    variantImage.height = 60
    variantImage.width = 60
    variantImage.alt = state.layout
    orderInfoEl.id = 'order-info-ab'
    orderInfoEl.innerHTML = `<span id="order-info-ab-layout">${state.layout}</span> / <span id="order-info-ab-size">${state.size}</span>`

    const layoutTextEl = orderInfoEl.querySelector('#order-info-ab-layout')
    const sizeTextEl = orderInfoEl.querySelector('#order-info-ab-size')

    if (isNotNullOrUndef(insideBtnWrapper)) {
      insideBtnWrapper.classList.add('inside-wrapper-product-button-ab')
      insideBtnWrapper.children[1].children[1].appendChild(orderInfoEl)
      insideBtnWrapper.append(variantImage)
    }

    const updateSize = (size) => {
      isNotNullOrUndef(sizeTextEl) && (sizeTextEl.innerHTML = size)
    }

    const updateLayoutAndImage = (layout) => {
      setTimeout(() => {
        layoutTextEl.innerHTML = layout
        variantImage.src = elements.image.src
        variantImage.alt = layout
      }, 100)
    }

    updateLayoutAndImage(state.layout)
    updateSize(state.size)
    triggers.on('state:layout', updateLayoutAndImage)
    triggers.on('state:size', updateSize)
  }
}

export default addButton
